/**
 * @generated SignedSource<<61867f3022ca8769466a918b40616334>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutHelp_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHelpContent_viewer">;
  readonly " $fragmentType": "CheckoutHelp_viewer";
};
export type CheckoutHelp_viewer$key = {
  readonly " $data"?: CheckoutHelp_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHelp_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutHelp_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHelpContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7a1993712573588ad520bb01414240f5";

export default node;
